import script from "./GalleryImageList.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryImageList.vue?vue&type=script&setup=true&lang=js"

import "./GalleryImageList.vue?vue&type=style&index=0&id=2f9ed62d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9ed62d"]])

export default __exports__